import React from "react";
import { MdAccessTime } from "react-icons/md";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import tut_1 from "../assets/img/tutorials/tut_1.jpeg";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

const tutorialData = [
  {
    title: "React for Beginners",
    desc: "Learn the basics of React and build your first application.",
    time: "30 min",
    image: tut_1, // Replace with actual image paths
  },
  {
    title: "Advanced React Patterns",
    desc: "Master advanced patterns and hooks in React development.",
    time: "45 min",
    image: tut_1,
  },
  {
    title: "Tailwind CSS Tutorial",
    desc: "Learn how to style applications with Tailwind CSS.",
    time: "20 min",
    image: tut_1,
  },
  {
    title: "Tailwind CSS Tutorial",
    desc: "Learn how to style applications with Tailwind CSS.",
    time: "20 min",
    image: tut_1,
  },
];

function Tutorials() {
  return (
    <div className="page_overflow">
      <section className="tutorials">
        <div className="container">
          <div className="section_title">
            <h1>Tutorials</h1>
          </div>
          <div>
            <h3 className="mb-4">How to Use Our Platform</h3>
            <Swiper
              modules={[Navigation]}
              spaceBetween={20}
              slidesPerView={1}
              navigation
              onSwiper={(swiper) => console.log(swiper)}
              breakpoints={{
                640: {
                  slidesPerView: 1, // 1 slide on small screens (e.g., mobile)
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2, // 2 slides on medium screens (e.g., tablets)
                  spaceBetween: 15,
                },
                1024: {
                  slidesPerView: 3, // 3 slides on large screens (e.g., desktops)
                  spaceBetween: 20,
                },
              }}
            >
              {tutorialData.map((tutorial, index) => (
                <SwiperSlide key={index}>
                  <div className="card">
                    <div className="card_img">
                      <img src={tutorial.image} alt={tutorial.title} />
                    </div>
                    <div className="card-body">
                      <h3>{tutorial.title}</h3>
                      <p>{tutorial.desc}</p>
                    </div>
                    <p className="tut_footer">
                      <MdAccessTime />
                      {tutorial.time}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="mt-4">
            <h3 className="mb-4">The Dispute/ Repair Process</h3>
            <Swiper
              modules={[Navigation]}
              spaceBetween={20}
              slidesPerView={1}
              navigation
              onSwiper={(swiper) => console.log(swiper)}
              breakpoints={{
                640: {
                  slidesPerView: 1, // 1 slide on small screens (e.g., mobile)
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2, // 2 slides on medium screens (e.g., tablets)
                  spaceBetween: 15,
                },
                1024: {
                  slidesPerView: 3, // 3 slides on large screens (e.g., desktops)
                  spaceBetween: 20,
                },
              }}
            >
              {tutorialData.map((tutorial, index) => (
                <SwiperSlide key={index}>
                  <div className="card">
                    <div className="card_img">
                      <img src={tutorial.image} alt={tutorial.title} />
                    </div>
                    <div className="card-body">
                      <h3>{tutorial.title}</h3>
                      <p>{tutorial.desc}</p>
                    </div>
                    <p className="tut_footer">
                      <MdAccessTime />
                      {tutorial.time}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="mt-4">
            <h3 className="mb-4">Funding</h3>
            <Swiper
              modules={[Navigation]}
              spaceBetween={20}
              slidesPerView={1}
              navigation
              onSwiper={(swiper) => console.log(swiper)}
              breakpoints={{
                640: {
                  slidesPerView: 1, // 1 slide on small screens (e.g., mobile)
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2, // 2 slides on medium screens (e.g., tablets)
                  spaceBetween: 15,
                },
                1024: {
                  slidesPerView: 3, // 3 slides on large screens (e.g., desktops)
                  spaceBetween: 20,
                },
              }}
            >
              {tutorialData.map((tutorial, index) => (
                <SwiperSlide key={index}>
                  <div className="card">
                    <div className="card_img">
                      <img src={tutorial.image} alt={tutorial.title} />
                    </div>
                    <div className="card-body">
                      <h3>{tutorial.title}</h3>
                      <p>{tutorial.desc}</p>
                    </div>
                    <p className="tut_footer">
                      <MdAccessTime />
                      {tutorial.time}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Tutorials;
